var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllProductIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_850_1842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5709 15.0512V16.4083H9.5V8.33744H17.2853C17.3228 8.33744 17.3599 8.34483 17.3946 8.35918C17.4292 8.37354 17.4607 8.39458 17.4872 8.4211C17.5137 8.44762 17.5348 8.47911 17.5491 8.51377C17.5635 8.54842 17.5709 8.58556 17.5709 8.62307V13.7869",
    stroke: "#8E8A8B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5353 8.33739H12.5718V10.4806C12.5718 10.6075 12.706 10.6896 12.8189 10.6317L13.4579 10.3041C13.4818 10.2918 13.5084 10.2854 13.5353 10.2854C13.5622 10.2854 13.5888 10.2918 13.6127 10.3041L14.2517 10.6317C14.3646 10.6896 14.4988 10.6075 14.4988 10.4806V8.33739H13.5353Z",
    stroke: "#8E8A8B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8948 15.0512H12.1757C12.1324 15.0512 12.0908 15.034 12.0601 15.0033C12.0295 14.9727 12.0122 14.9311 12.0122 14.8877V13.7209C12.0122 13.6776 12.0295 13.636 12.0601 13.6053C12.0908 13.5746 12.1324 13.5574 12.1757 13.5574H14.8948C14.9382 13.5574 14.9798 13.5746 15.0104 13.6053C15.0411 13.636 15.0583 13.6776 15.0583 13.7209V14.8877C15.0583 14.9311 15.0411 14.9727 15.0104 15.0033C14.9798 15.034 14.9382 15.0512 14.8948 15.0512Z",
    stroke: "#8E8A8B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46436 3.21175V8.33728H13.5352V0.551757C13.5352 0.514279 13.5279 0.477167 13.5135 0.442542C13.4992 0.407916 13.4782 0.376456 13.4517 0.349956C13.4252 0.323457 13.3937 0.302438 13.3591 0.288099C13.3244 0.27376 13.2873 0.266382 13.2498 0.266387H5.74999C5.71248 0.266387 5.67533 0.273775 5.64068 0.288129C5.60603 0.302483 5.57454 0.323523 5.54801 0.350046C5.52149 0.376569 5.50045 0.408057 5.4861 0.442711C5.47174 0.477365 5.46436 0.514507 5.46436 0.552017V1.9474",
    stroke: "#8E8A8B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49967 0.266399H8.53613V2.40964C8.53613 2.53656 8.67036 2.61857 8.78332 2.56068L9.42226 2.23315C9.44623 2.22088 9.47277 2.21448 9.49969 2.21448C9.52662 2.21448 9.55316 2.22088 9.57712 2.23315L10.2161 2.56068C10.329 2.61857 10.4632 2.53656 10.4632 2.40964V0.266399H9.49967Z",
    stroke: "#8E8A8B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8596 6.98022H8.14059C8.11911 6.98022 8.09784 6.97599 8.078 6.96777C8.05815 6.95955 8.04012 6.9475 8.02494 6.93231C8.00975 6.91712 7.99771 6.89909 7.98949 6.87924C7.98127 6.8594 7.97705 6.83813 7.97705 6.81665V5.64993C7.97705 5.60656 7.99428 5.56496 8.02495 5.53429C8.05562 5.50362 8.09722 5.48639 8.14059 5.48639H10.8596C10.8811 5.48639 10.9023 5.49061 10.9222 5.49883C10.942 5.50705 10.9601 5.51909 10.9752 5.53428C10.9904 5.54947 11.0025 5.5675 11.0107 5.58734C11.0189 5.60719 11.0231 5.62845 11.0231 5.64993V6.81665C11.0231 6.83813 11.0189 6.8594 11.0107 6.87925C11.0025 6.8991 10.9904 6.91713 10.9753 6.93232C10.9601 6.94751 10.942 6.95956 10.9222 6.96778C10.9023 6.976 10.8811 6.98023 10.8596 6.98022Z",
    stroke: "#8E8A8B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50009 16.4083H1.4292V8.62307C1.42921 8.54732 1.45931 8.47467 1.51287 8.42111C1.56643 8.36754 1.63908 8.33745 1.71483 8.33744H9.50009V16.4083Z",
    stroke: "#8E8A8B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46452 8.33739H4.50098V10.4806C4.50098 10.6075 4.6352 10.6896 4.74816 10.6317L5.38711 10.3041C5.41106 10.2918 5.4376 10.2854 5.46452 10.2854C5.49144 10.2854 5.51798 10.2918 5.54193 10.3041L6.18088 10.6317C6.29384 10.6896 6.42802 10.6075 6.42802 10.4806V8.33739H5.46452Z",
    stroke: "#8E8A8B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82394 15.0512H4.10495C4.06157 15.0512 4.01998 15.034 3.98931 15.0033C3.95864 14.9727 3.94141 14.9311 3.94141 14.8877V13.7209C3.94141 13.6776 3.95864 13.636 3.98931 13.6053C4.01998 13.5746 4.06157 13.5574 4.10495 13.5574H6.82394C6.86732 13.5574 6.90891 13.5746 6.93958 13.6053C6.97025 13.636 6.98748 13.6776 6.98748 13.7209V14.8877C6.98748 14.9311 6.97025 14.9727 6.93958 15.0033C6.90891 15.034 6.86732 15.0512 6.82394 15.0512Z",
    stroke: "#8E8A8B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5928 17.4904H0.40699C0.370663 17.4904 0.335825 17.476 0.310138 17.4503C0.284451 17.4246 0.27002 17.3897 0.27002 17.3534V16.5454C0.27002 16.509 0.284451 16.4742 0.310138 16.4485C0.335825 16.4228 0.370663 16.4084 0.40699 16.4084H18.5928C18.6107 16.4084 18.6285 16.4119 18.6452 16.4188C18.6618 16.4257 18.6769 16.4358 18.6896 16.4485C18.7023 16.4612 18.7124 16.4763 18.7193 16.4929C18.7262 16.5096 18.7297 16.5274 18.7297 16.5454V17.3534C18.7297 17.3714 18.7262 17.3892 18.7193 17.4058C18.7124 17.4224 18.7023 17.4375 18.6896 17.4503C18.6769 17.463 18.6618 17.4731 18.6452 17.48C18.6285 17.4868 18.6107 17.4904 18.5928 17.4904Z",
    stroke: "#8E8A8B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4429 18.7337H16.6333C16.5758 18.7337 16.5207 18.7108 16.48 18.6702C16.4393 18.6295 16.4165 18.5744 16.4165 18.5169V17.4904H17.6597V18.5169C17.6597 18.5744 17.6369 18.6295 17.5962 18.6702C17.5556 18.7108 17.5004 18.7337 17.4429 18.7337Z",
    stroke: "#8E8A8B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.36629 18.7337H1.5566C1.49911 18.7337 1.44398 18.7108 1.40333 18.6702C1.36268 18.6295 1.33984 18.5744 1.33984 18.5169V17.4904H2.58308V18.5169C2.58307 18.5744 2.56022 18.6295 2.51957 18.6702C2.47892 18.7108 2.42378 18.7337 2.36629 18.7337Z",
    stroke: "#8E8A8B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_850_1842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllProductIcon);
export default __webpack_public_path__ + "static/media/allProductIcon.a858b5c0472d1eb4b3bb0e0d63d7bf07.svg";
export { ForwardRef as ReactComponent };